import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { getTrackingEventLabel } from "./getTrackingEventLabel";
var EVENT_CATEGORY = 'Navigation - MDD';
export var megaNavOpen = function megaNavOpen(navigationData, item) {
  return sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Mega Nav Open',
    event_label: getTrackingEventLabel(navigationData, item),
    destination_URL: item.url
  });
};
export var clickLink = function clickLink(evt, navigationData, item) {
  return sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Click',
    event_label: getTrackingEventLabel(navigationData, item),
    destination_URL: item.url
  });
};